// extracted by mini-css-extract-plugin
export var boldText = "_4r-4";
export var checkboxContainer = "_4r-6";
export var closeIcon = "_4r-i";
export var container = "_4r-0";
export var drawer = "_4r-8";
export var drawerContent = "_4r-9";
export var extraSmallText = "_4r-5";
export var fulfillmentGroupTable = "_4r-e";
export var largeText = "_4r-3";
export var loadingSpinnerContainer = "_4r-j";
export var mediumText = "_4r-2";
export var narrow = "_4r-f";
export var notificationLink = "_4r-l";
export var packageCheckIconContainer = "_4r-7";
export var slideoutHeaderActions = "_4r-g";
export var slideoutHeaderActionsShifted = "_4r-h";
export var slideoutHeaderContainer = "_4r-a";
export var slideoutModal = "_4r-c";
export var stickyHeaderWrapper = "_4r-b";
export var table = "_4r-k";
export var tableContainer = "_4r-d";
export var tertiaryText = "_4r-1";